"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marketboard = void 0;
class Marketboard {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created MarketboardSymbol object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Marketboard = Marketboard;
//# sourceMappingURL=Marketboard.js.map